module.exports = __webpack_public_path__ + "img/p.41f997ce.png";